import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import QualificationsFormFields from './QualificationsFormFields'

class QualificationsForm extends React.Component {

    render() {
        const {
            values,
        } = this.props;

        return <QualificationsFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            name: '',
        });
    },

    // validationSchema: () => {
    //     let rules = object().shape({
    //         salutation: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.salutation')})
    //         ),
    //         first_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
    //         ),
    //         last_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')})
    //         ),
    //
    //         street: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.street')})
    //         ),
    //         housenumber: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.housenumber')})
    //         ),
    //         zip: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.zip')})
    //         ),
    //         city: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.city')})
    //         ),
    //     });
    //
    //     return rules
    // },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('qualifications.save_success'),
                text: i18n.get('qualifications.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('qualifications.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(QualificationsForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Qualifications/QualificationsForm.js